import C from 'utils/values/constant.util';

const VACATION_TYPE = C([
  Object.freeze({ emoji: '🌴', type: 'HOLIDAY' }),
  Object.freeze({ emoji: '🤒', type: 'SICK LEAVE' }),
  Object.freeze({ emoji: '⛔️', type: 'BUSY TIME' }),
  Object.freeze({ emoji: '👩', type: 'COLLEGE' }),
  Object.freeze({ emoji: '🔄', type: 'REGULAR DAY OFF' }),
]);

export default VACATION_TYPE;
